var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.purchaseOrderStatusList,"itemText":"key","dense":"","hideDetails":"","outlined":""},model:{value:(_vm.purchaseOrderStatus),callback:function ($$v) {_vm.purchaseOrderStatus=$$v},expression:"purchaseOrderStatus"}})
}
var staticRenderFns = []

export { render, staticRenderFns }